export default __webpack_public_path__ + "static/media/checkout-image.ea24b580.png";